import React from "react";
import Layout from "../Layout/Layout";
import Ecom from "../../components/Ecom/Ecom";

function EcomFlow() {
  return (
    <Layout child="Ecom">
      <Ecom />
    </Layout>
  );
}

export default EcomFlow;
